import React, { useState } from 'react';
import { CHEQUE_PAYMENT_MODE_KEY, segregateRefundDetails, useGetMultiTypeRefundStep3Utils, useGetStudentAndVendorAccountDetails } from '../utils';
import { useWizard } from '../../../../../components/wizard/WizardContext';
import ALoader from '../../../../../views/pages/manage/common/a-loader';
import Footer from '../../../../studentTransfer/components/Footer';
import AButton from '../../../../../views/pages/manage/common/form-fields-mui/AButton';
import RefundAccountsCard from './RefundAccountsCard';
import { useNavigateToGivenPath } from '../../../../../views/pages/manage/edpOps/studentDetails/paymentSummary/service';
import { useSaveDataToConfigValues } from '../../rectificationRefund/selectRefundReasonAndReceipt/utils';
import EyeIcon from "assets/img/svg/svgComponents/EyeIcon";
import { failureToast } from '../../../../../views/pages/manage/common/utils/methods/toasterFunctions/function';
import { REFUND_MANAGE_ACCOUNTS } from '../../../../../views/pages/manage/edpOps/studentDetails/constant';

export const EMPTY_CHEQUE_DETAILS_FORM = {
    paymentModeType : CHEQUE_PAYMENT_MODE_KEY
}

const getInitialChequeDetails = (values, forRefundEdit) => {

    const { multiTypeRefundStep3Data, raisedRefundDetails } = values;
    const { primaryStudentAccount } = multiTypeRefundStep3Data;
    const { chequeDetailsSaved} = primaryStudentAccount ?? {};

    if (forRefundEdit && 
        !primaryStudentAccount //to ensure that previously filled cheque details are auto-filled only on first visit to step3
    ) { 
        const { refundAccountDetails } = segregateRefundDetails(raisedRefundDetails);
        const accountDetails = refundAccountDetails?.[0] ?? {};
        const isChequePaymentMode = accountDetails?.paymentModeType === CHEQUE_PAYMENT_MODE_KEY;
        if (isChequePaymentMode) return { ...accountDetails, chequeDetailsSaved: true }
    }

    if (chequeDetailsSaved) {
        return primaryStudentAccount;
    }

    return { ...EMPTY_CHEQUE_DETAILS_FORM };

}


const SelectRefundAccounts = () => {

    const { values, next, params } = useWizard();
    const navigateToGivenPath = useNavigateToGivenPath();

    const forRefundEdit = params?.mode === 'edit';

    const { multiTypeRefundStep3Data, multiTypeRefundUtils, selectedStudent, multiTypeRefundStep2Data } = values;
    const { psid } = selectedStudent;

    const { additionalStudentDetails, totalPayableToParent, totalPayableToVendor, isFranchiseBuType } = multiTypeRefundStep2Data;
    const { studentLoanDetails = {} } = additionalStudentDetails;
    const {isLoanCase , loanScheme = {}} = studentLoanDetails;

    const { studentAccountDetails, loanVendorAccountDetails} = multiTypeRefundStep3Data;

    const [loading, setLoading] = useState(false);
    const [chequeDetailsForm, setChequeDetailsForm] = useState(() => getInitialChequeDetails(values, forRefundEdit));



    console.log('multiTypeRefundStep2Data', multiTypeRefundStep2Data);

    const backToPrevStep = () => next(0);

    //Refactor : these both hooks can be merged into one
    // useGetStudentAndVendorAccountDetails(setLoading, isLoanCase , loanScheme);
    useGetMultiTypeRefundStep3Utils();

    const primaryStudentAccount = chequeDetailsForm?.chequeDetailsSaved ? chequeDetailsForm : studentAccountDetails?.find(details => details?.accountType === 'Primary' && details?.bankStatus === 'ACTIVE');
    const loanVendorAccount = loanVendorAccountDetails?.[0];

    console.log('loanVendorAccount', loanVendorAccount);

    const handleProceedNext = () => {
        if(totalPayableToParent > 0 && !primaryStudentAccount ){
            failureToast("Primary student refund account missing or inactive. Please add or activate a primary account!");
            return;
        }
        if(totalPayableToVendor > 0 && (!loanVendorAccount || loanVendorAccount?.bankStatus !== 'ACTIVE')){
            failureToast("No active vendor account details found!");
            return;
        }

        next();

    }

    useSaveDataToConfigValues({
        studentAccountDetails,
        primaryStudentAccount,
        loanVendorAccount
    }, "multiTypeRefundStep3Data")


    return (
        <div className='d-flex flex-column justify-content-between' style={{minHeight : '80vh'}}>
            <div className='d-flex flex-column m-2' style={{gap : '1rem'}}>

                {(loading || multiTypeRefundUtils?.loading) && <ALoader position={"fixed"} />}

                {(totalPayableToParent > 0 ) && <RefundAccountsCard
                    accountDetails={[...studentAccountDetails, ...(isFranchiseBuType ? [chequeDetailsForm] : [])]}
                    multiTypeRefundUtils={multiTypeRefundUtils}
                    title={"Student Account Details"}
                    manageAccountsClickHandler={() => {
                        navigateToGivenPath(`admin/edp/studentDetails/${psid}?source=${REFUND_MANAGE_ACCOUNTS}`);
                        backToPrevStep();
                    }}
                    openDetailsDialogIcon={<EyeIcon/>}
                    amount={totalPayableToParent}
                    primaryStudentAccount={primaryStudentAccount}
                    setChequeDetailsForm={setChequeDetailsForm}
                />
}

                {(totalPayableToVendor > 0) && <RefundAccountsCard
                    accountDetails={loanVendorAccountDetails}
                    multiTypeRefundUtils={multiTypeRefundUtils}
                    title={"Third party refund account"}
                    openDetailsDialogIcon={<EyeIcon/>}
                    manageAccountsClickHandler={() => {
                        navigateToGivenPath('admin/setupBankAcc/thirdPartyBankAccSetup');
                        backToPrevStep();
                    }}
                    amount={totalPayableToVendor}
                />}

            </div>

            <Footer>
                <div>Select Refund Accounts</div>
                <AButton
                    // disabled={}
                    onClick={handleProceedNext}
                    className="button_remove_left_margin"
                    variant="primary_filled"
                >
                    Proceed next
                </AButton>
            </Footer>
        </div>

    );
}

export default SelectRefundAccounts;